import React from 'react';

// Demo card shows OVR 87 = Brilliant tier
const RARITY_STYLE = {
  background: 'linear-gradient(145deg, #0a0a1a 0%, #1a0a2e 25%, #0d1a3a 50%, #1a0a2e 75%, #0a0a1a 100%)',
  border: '1.5px solid rgba(147,51,234,0.8)',
  boxShadow: '0 0 50px rgba(147,51,234,0.5), 0 0 100px rgba(147,51,234,0.2)',
  ovrColor: '#e879f9',
  nameColor: '#f0abfc',
  accentColor: '#a855f7',
  accentRgb: '168,85,247',
  divider: 'linear-gradient(90deg, transparent, #a855f7, #e879f9, #a855f7, transparent)',
};

export default function DemoCard() {
  const stats = [
    { label: 'PAC', value: 87 },
    { label: 'SHO', value: 82 },
    { label: 'PAS', value: 74 },
    { label: 'DRI', value: 89 },
    { label: 'DEF', value: 41 },
    { label: 'PHY', value: 78 },
  ];

  return (
    <div className="flex flex-col items-center">
      {/* Rarity badge */}
      <div className="mb-2">
        <span
          className="text-xs font-black tracking-widest px-3 py-1 rounded-full border"
          style={{
            color: '#e879f9',
            borderColor: 'rgba(168,85,247,0.4)',
            background: 'rgba(168,85,247,0.1)',
          }}
        >
          ★ BRILLIANT
        </span>
      </div>

      <div className="card-3d-wrapper w-52 mx-auto select-none">
        <div
          className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.8)]"
          style={{
            background: RARITY_STYLE?.background,
            border: RARITY_STYLE?.border,
            width: '208px',
            height: '296px',
            boxShadow: RARITY_STYLE?.boxShadow,
          }}
        >
          {/* Shine overlay */}
          <div className="absolute inset-0 card-shine pointer-events-none z-10" />

          {/* Brilliant animated overlay */}
          <div
            className="absolute inset-0 pointer-events-none z-5 opacity-20"
            style={{
              background: 'linear-gradient(135deg, transparent 0%, rgba(168,85,247,0.4) 25%, transparent 50%, rgba(236,72,153,0.4) 75%, transparent 100%)',
            }}
          />

          {/* Top section */}
          <div className="relative z-20 px-4 pt-4">
            <div className="flex items-start justify-between">
              <div className="text-center">
                <div
                  className="font-mono-nums text-5xl font-black leading-none"
                  style={{ color: RARITY_STYLE?.ovrColor, textShadow: '0 0 20px rgba(168,85,247,0.8)' }}
                >
                  87
                </div>
                <div className="text-xs font-bold tracking-widest mt-0.5" style={{ color: RARITY_STYLE?.accentColor }}>
                  CAM
                </div>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-8 h-5 rounded-sm bg-secondary flex items-center justify-center">
                  <span className="text-xs">🇺🇿</span>
                </div>
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center"
                  style={{
                    background: `rgba(${RARITY_STYLE?.accentRgb},0.2)`,
                    border: `1px solid rgba(${RARITY_STYLE?.accentRgb},0.4)`,
                  }}
                >
                  <span className="text-xs font-black" style={{ color: RARITY_STYLE?.accentColor }}>FC</span>
                </div>
              </div>
            </div>
          </div>

          {/* Player silhouette */}
          <div className="relative z-20 flex items-center justify-center mt-1">
            <div
              className="w-28 h-28 rounded-full flex items-center justify-center overflow-hidden"
              style={{ background: `radial-gradient(circle, rgba(${RARITY_STYLE?.accentRgb},0.15), transparent)` }}
            >
              <svg viewBox="0 0 80 80" width="80" height="80" fill="none">
                <circle cx="40" cy="18" r="10" fill={`rgba(${RARITY_STYLE?.accentRgb},0.7)`} />
                <path d="M20 70 Q20 45 40 42 Q60 45 60 70" fill={`rgba(${RARITY_STYLE?.accentRgb},0.6)`} />
                <path d="M28 50 L22 68" stroke={`rgba(${RARITY_STYLE?.accentRgb},0.5)`} strokeWidth="5" strokeLinecap="round" />
                <path d="M52 50 L58 68" stroke={`rgba(${RARITY_STYLE?.accentRgb},0.5)`} strokeWidth="5" strokeLinecap="round" />
              </svg>
            </div>
          </div>

          {/* Player name */}
          <div className="relative z-20 text-center px-2 mt-1">
            <div className="text-sm font-black tracking-widest uppercase" style={{ color: RARITY_STYLE?.nameColor }}>
              YOUR NAME
            </div>
          </div>

          {/* Divider */}
          <div className="mx-4 my-2 h-px" style={{ background: RARITY_STYLE?.divider }} />

          {/* Stats grid */}
          <div className="relative z-20 px-3 pb-3 grid grid-cols-3 gap-x-2 gap-y-1">
            {stats?.map((s) => (
              <div key={`demo-stat-${s?.label}`} className="flex items-center gap-1">
                <span className="font-mono-nums text-sm font-bold" style={{ color: RARITY_STYLE?.ovrColor }}>{s?.value}</span>
                <span className="text-xs font-semibold" style={{ color: `rgba(${RARITY_STYLE?.accentRgb},0.7)` }}>{s?.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}